import { render } from "./SortByPopover.vue?vue&type=template&id=7b95ef71&scoped=true&ts=true"
import script from "./SortByPopover.vue?vue&type=script&lang=ts"
export * from "./SortByPopover.vue?vue&type=script&lang=ts"

import "./SortByPopover.vue?vue&type=style&index=0&id=7b95ef71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b95ef71"]])

export default __exports__